import { createBrowserRouter } from 'react-router-dom';

import { baseRouter } from './common/baseRouter';

export const router = createBrowserRouter([
  {
    path: '',
    children: baseRouter,
  },
]);
